import script from "./PersonnelView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonnelView.vue?vue&type=script&setup=true&lang=js"

import "./PersonnelView.vue?vue&type=style&index=0&id=2fd81ad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fd81ad2"]])

export default __exports__